import { Status } from "@common/models";

export class ReportType {
    id?: number;
    name?: string;
    nameEnglish?: string;
    description?: string;
    status?: Status = new Status();
}
